import { ROLE_ADMIN } from '@/enum/roles'
import routeType from '@/router/routeType'

const meta = {
    requiresAuth: true,
    roles: [ROLE_ADMIN],
    layout: 'ordit-authenticated-layout',
}

const passthroughRender = {
    render: (c) => c('router-view'),
}

export default [
    {
        path: '/custom-export-category',
        component: passthroughRender,
        meta,
        children: [
            {
                path: '',
                name: routeType.CUSTOM_EXPORT_CATEGORY_LIST,
                component: () =>
                    import(
                        /* webpackChunkName: "custom-export-category-list" */ '@/pages/customExportCategory/List.vue'
                    ),
                meta,
            },
            {
                path: 'create',
                name: routeType.CUSTOM_EXPORT_CATEGORY_CREATE,
                component: () =>
                    import(
                        /* webpackChunkName: "custom-export-category-create" */ '@/pages/customExportCategory/Create.vue'
                    ),
                meta: {
                    ...meta,
                },
            },
            {
                path: ':id',
                name: routeType.CUSTOM_EXPORT_CATEGORY_EDIT,
                component: () =>
                    import(
                        /* webpackChunkName: "custom-export-category-edit" */ '@/pages/customExportCategory/Edit.vue'
                    ),
                meta: {
                    ...meta,
                },
            },
        ],
    },
]
